import { Flex } from '@mantine/core';
import { AddressRes } from '@dealstack/shared/lib/generated';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { InvestorDetailsCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/InvestorDetailsCard/InvestorDetailsCard.tsx';
import { AddressItem } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/AddressesCard/AddressItem.tsx';
import { sortAddressesTaggedFirst } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/AddressesCard/addresses.utils.ts';

interface Props {
	addresses: AddressRes[] | undefined;
}

export const AddressesCard = ({ addresses }: Props) => {
	const tMipManage = useTranslationMipManage();

	if (!addresses?.length) {
		return null;
	}

	const sortedAddresses = sortAddressesTaggedFirst(addresses);

	return (
		<InvestorDetailsCard
			title={tMipManage('investors.details.addresses_card.title')}
			count={addresses.length}
			action={{ kind: 'expand' }}
			dataTestId={TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_ADDRESSES_CARD}
		>
			<Flex direction="column" gap="0.25rem">
				{sortedAddresses.map((address) => (
					<AddressItem key={address.id} address={address} />
				))}
			</Flex>
		</InvestorDetailsCard>
	);
};
